import { render } from "./generate-document.vue?vue&type=template&id=95c74972&scoped=true"
import script from "./generate-document.vue?vue&type=script&lang=js"
export * from "./generate-document.vue?vue&type=script&lang=js"

import "./generate-document.vue?vue&type=style&index=0&id=95c74972&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c74972"]])

export default __exports__